// noinspection JSUnusedGlobalSymbols

/*
 * Copyright (c) 2008-2026 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
import omit from "lodash/omit"

export const defaultUserProperties = Object.freeze({
  SALUTATION: "salutation",
  TITLE: "title",
  FIRST_NAME: "firstname",
  LAST_NAME: "lastname",
  USER_NAME: "username",
  EMAIL: "email",
  HIDE_TOUR_MODALS: "internal:hidetourmodals",
  ACTIVE_MEETING_SORT_OPTION: "internal:activemeetingsortoption",
  MEETING_FILTER_CONFIG: "internal:meetingfilterconfig",
})

const participantBaseProperties = omit(defaultUserProperties, ["SALUTATION", "TITLE", "USER_NAME", "EMAIL"])

export const defaultParticipantProperties = Object.freeze({
  ...participantBaseProperties,

  DISPLAY_NAME: "displayname",
  DELEGATE: "delegate",
  FAVORITE: "favorite",
  USER_GROUPS: "categories",
  LOGIN_LINK: "loginlink",
  ACCREDITED: "accredited",
})

// Properties not supported when editing users
export const unsupportedParticipantProperties = [defaultParticipantProperties.LOGIN_LINK]

// Property prefixes of predefined properties
export const predefinedPropertyPrefixes = ["tool:"]

// Prefixes of properties not shown
export const hiddenPropertyPrefixes = ["hidden:", "internal:"]

// Predefined properties in UserDialogParticipant appear in the order defined here
export const predefinedParticipantProperties = Object.freeze({
  title: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  firstname: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  lastname: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  displayname: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  email: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  votingweight: {
    type: "NUMBER",
    value: 1,
    exportable: true,
  },
  delegate: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  categories: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  skipwaitingroom: {
    type: "BOOLEAN",
    value: false,
    exportable: false,
  },
  accredited: {
    type: "BOOLEAN",
    value: false,
    exportable: true,
  },
  locale: {
    type: "STRING",
    value: "",
    exportable: true,
  },
  favorite: {
    type: "BOOLEAN",
    value: false,
    exportable: false,
  },
})
